import { MoveRightIcon } from 'lucide-react'

import { TxOverview } from '../types'
import { assets } from '@/ui/assets'
import { TransactionOverview as TransactionOverviewComponent } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export function TransactionOverview(txOverview: TxOverview) {
  if (txOverview.status !== 'success') {
    return <TransactionOverviewPlaceholder />
  }

  return (
    <TransactionOverviewComponent providedBy="spark">
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>APY</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.ApyChange currentApy={txOverview.currentApy} updatedApy={txOverview.updatedApy} />
      </TransactionOverviewComponent.Row>
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>Spark Points</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.Generic className="flex items-center gap-2.5">
          <PointsMultiplier pointsMultiplier={txOverview.pointsMultiplierBefore} />
          <MoveRightIcon className="icon-size-xxs icon-secondary" />
          <PointsMultiplier pointsMultiplier={txOverview.pointsMultiplierAfter} />
        </TransactionOverviewComponent.Generic>
      </TransactionOverviewComponent.Row>
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>Outcome</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.SavingsOutcome
          token={txOverview.susdc}
          amount={txOverview.susdcUpgradedAmount}
          postFix="Upgraded to Savings USDC V2"
          dataTestId={testIds.dialog.savings.transactionOverview.outcome}
        />
      </TransactionOverviewComponent.Row>
    </TransactionOverviewComponent>
  )
}

function TransactionOverviewPlaceholder() {
  return (
    <TransactionOverviewComponent providedBy="spark">
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>APY</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.Generic>-</TransactionOverviewComponent.Generic>
      </TransactionOverviewComponent.Row>
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>Spark Points</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.Generic>-</TransactionOverviewComponent.Generic>
      </TransactionOverviewComponent.Row>
      <TransactionOverviewComponent.Row>
        <TransactionOverviewComponent.Label>Outcome</TransactionOverviewComponent.Label>
        <TransactionOverviewComponent.Generic>-</TransactionOverviewComponent.Generic>
      </TransactionOverviewComponent.Row>
    </TransactionOverviewComponent>
  )
}

function PointsMultiplier({ pointsMultiplier }: { pointsMultiplier: number }) {
  if (pointsMultiplier === 0) {
    return <div>No Points</div>
  }

  return (
    <div className="flex items-center gap-1">
      <img src={assets.points.pointsIcon} alt="spark-points-icon" className="size-5" />
      <div className="typography-label-2 bg-[linear-gradient(179.89deg,#FA43BD_-22.08%,#FFCD4D_163.67%)] bg-clip-text text-transparent">
        {pointsMultiplier}x Multiplier
      </div>
    </div>
  )
}
